import React, { Component } from "react";
import { ReactSVG } from "react-svg";
import Bdt from "../../assets/static/svg/bdt.svg";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import LangChanger from "../../redux/helper/lngChanger";
import { getSubInfo } from "../../redux/actions/subInfo";
import { loadState } from "../../LocalStore/localStorage";

export class PriceTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      msisdn: loadState("msisdn"),
      packList: [],
      pack: null,
      user_info: null,
      ifSub: null,
    };
  }

  async componentDidMount() {
    await this.props.dispatch(getSubInfo(this.state.msisdn));

    const { pack_list, user_info } = this.props.getSubInfo?.error
      ? []
      : this.props.getSubInfo;

    await this.setState({
      packList: pack_list || [],
      pack: pack_list ? pack_list[1] : null,
      user_info,
    });

    this.isSubInfoFilter();
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.getSubInfo !== this.props.getSubInfo &&
      this.props.getSubInfo?.pack_list
    ) {
      const { pack_list, user_info } = this.props.getSubInfo?.error
        ? []
        : this.props.getSubInfo;

      await this.setState({
        packList: pack_list || [],
        pack: pack_list ? pack_list[1] : null,
        user_info,
      });

      this.isSubInfoFilter();
    }
  }

  isSubInfoFilter = () => {
    const { packList } = this.state;
    const subscribed = packList?.find((item) => item.is_subscribe === true);

    this.setState({ ifSub: subscribed || null });
  };

  render() {
    const { t } = this.props;
    const { packList, user_info, ifSub } = this.state;

    return (
      <div className="priceTableWrap" id="landingPrice">
        <div className="container">
          {/* Title */}
          <div className="row">
            <div className="col-12 text-center my-4">
              <h2 className="secTitle2">{t("PricingTable")}</h2>
            </div>
          </div>

          {/* If not subscribed: show all plans */}
          {!ifSub && packList && packList.length > 0 && (
            <div className="pricing-grid">
              {packList.map((item, i) => (
                <div key={i} className="pricing-grid-item">
                  <div className="pricing-card">
                    {/* Subtitle */}
                    <h3 className="pricing-subtitle">
                      {LangChanger(
                        t("ln"),
                        item.pack_name_en,
                        item.pack_name_bn
                      )}
                    </h3>

                    {/* Price */}
                    <h1 className="pricing-price">
                      <span>
                        {LangChanger(t("ln"), item.price_en, item.price_bn)}
                      </span>
                      <span className="pricing-bdt-icon">
                        <ReactSVG src={Bdt} />
                      </span>
                    </h1>

                    {/* Billing Text */}
                    <p className="pricing-billing">
                      {LangChanger(
                        t("ln"),
                        item.billing_message_en,
                        item.billing_message_bn
                      )}
                    </p>

                    {/* Subscribe Button */}
                    {user_info && user_info.sub_status === 0 && (
                      <a href={item.sub_unsub_url} className="pricing-btn">
                        Subscribe
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* If already subscribed: show single active plan */}
          {ifSub && (
            <div className="pricing-grid single-card">
              <div className="pricing-grid-item">
                <div className="pricing-card">
                  <h3 className="pricing-subtitle">Subscribed</h3>

                  <h3 className="pricing-subtitle">
                    {LangChanger(
                      t("ln"),
                      ifSub.pack_name_en,
                      ifSub.pack_name_bn
                    )}
                  </h3>

                  <h2 className="pricing-price">
                    <span>
                      {LangChanger(t("ln"), ifSub.price_en, ifSub.price_bn)}
                    </span>
                    <span className="pricing-bdt-icon">
                      <ReactSVG src={Bdt} />
                    </span>
                  </h2>

                  <p className="pricing-billing">
                    {LangChanger(
                      t("ln"),
                      ifSub.billing_message_en,
                      ifSub.billing_message_bn
                    )}
                  </p>


                  {ifSub.sub_unsub_url.length > 15 && (
                    <a href={ifSub.sub_unsub_url} className="pricing-btn">
                      Unsubscribe
                    </a>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  getSubInfo: state.getSubInfo,
});

export default withTranslation()(connect(mapStateToProps)(PriceTable));
